import { createSlice } from '@reduxjs/toolkit';
import { lithosMediaLogApi, mediaLogApi } from '../services/api';

export const lithosMediaLogSlice = createSlice({
	name: 'lithosMediaLog',
	initialState: {
		isLoading: false,
		mediaLogList: [],
		error: null,
	},
	reducers: {
		setLoading: (state) => {
			state.isLoading = true;
		},

		mediaLogData: (state, action) => {
			state.isLoading = false;
			state.mediaLogList = action.payload;
		},

		mediaLogErrorList: (state, action) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const { mediaLogData, setLoading, mediaLogErrorList } = lithosMediaLogSlice.actions;

export default lithosMediaLogSlice.reducer;

export const lithosMediaLogListRequest = (queryString) => async (dispatch, getState) => {
	dispatch(setLoading());
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: getState()?.auth?.Token,
			},
		};
		const { data } = await lithosMediaLogApi(queryString, config);
		dispatch(mediaLogData(data));
	} catch (error) {
		dispatch(mediaLogErrorList(error.response));
	}
};
